module.exports = __webpack_public_path__ + "static/media/5.c728f6c2.jpg";